'use client';

import {useRef} from 'react';

import {AppsSelection, AppType} from '@web-catalog/types';

import {
  useLogCompilationSwipe,
  useLogOnCompilationShow,
} from '@web-catalog/utils/analytics/interestingPage';

import {AppsCarousel} from './AppsCarousel';

type Props = {
  selection: AppsSelection | null | undefined;
  appType: AppType;
  displayedSelectionNumber: number;
};

export const AppsCarouselFromSelection = ({
  selection,
  appType,
  displayedSelectionNumber,
}: Props) => {
  const ref = useRef(null);
  useLogOnCompilationShow({
    ref,
    selection,
    selectionNumber: displayedSelectionNumber,
  });

  const onSwipe = useLogCompilationSwipe(selection, displayedSelectionNumber);
  if (!selection) {
    return null;
  }
  const apps = selection.content.flatMap((item) =>
    item.type === 'APPS' ? item.appInfo : [],
  );
  if (!apps.length) {
    return null;
  }
  return (
    <AppsCarousel
      ref={ref}
      title={selection.title?.value || ''}
      apps={apps}
      showLinkToAll={false}
      appType={appType}
      testId="selection_with_app_list"
      onSwipe={onSwipe}
    />
  );
};
